import C from "action-types";

export const submitInsuranceImport = data => {
  return {
    type: C.INSURANCE.INSURANCE_IMPORT,
    payload: data
  }
};